import React from 'react';
import PropTypes from "prop-types";
import clsx from "clsx";
import { useNavigate } from 'react-router-dom';

const NewsInsightSlider = ({ spaceTopClass, spaceBottomClass }) => {
  const navigate = useNavigate()
  // Sample data structure matching the new design
  const categoryData = [
    {
      "id": "1",
      "image": "/assets/img/category/21.png",
      "title": "Lorem Ipsum is Simply Dummy Text Of The Printing And Typesetting Industry.",
      "link": "/detail-blog?id=1",
      "date": "22 Jan, 2024",
      "type": "News"
    },
    {
      "id": "2",
      "image": "/assets/img/category/22.png",
      "title": "Lorem Ipsum is Simply Dummy Text Of The Printing And Typesetting Industry.",
      "link": "/detail-blog?id=2",
      "date": "22 Jan, 2024",
      "type": "Insight"
    },
    {
      "id": "3",
      "image": "/assets/img/category/23.png",
      "title": "Lorem Ipsum is Simply Dummy Text Of The Printing And Typesetting Industry.",
      "link": "/detail-blog?id=3",
      "date": "22 Jan, 2024",
      "type": "Insight"
    },
    {
      "id": "4",
      "image": "/assets/img/category/24.png",
      "title": "Lorem Ipsum is Simply Dummy Text Of The Printing And Typesetting Industry.",
      "link": "/detail-blog?id=4",
      "date": "22 Jan, 2024",
      "type": "News"
    }
  ];

  const cardStyle = {
    width: '280px',
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease',
    cursor: 'pointer',
  };

  const imageContainerStyle = {
    position: 'relative',
    height: '200px',
    overflow: 'hidden',
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };

  const labelStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: 'white',
    padding: '4px 12px',
    borderRadius: '5px',
    fontSize: '12px',
    fontWeight: '500',
  };

  const contentStyle = {
    padding: '20px',
  };

  const titleStyle = {
    fontSize: '16px',
    fontWeight: '500',
    marginBottom: '15px',
    lineHeight: '1.4',
    color: '#333',
  };

  const footerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: '1px solid #eee',
    padding: '15px 20px',
  };

  const dateStyle = {
    color: '#666',
    fontSize: '14px',
  };

  const readMoreStyle = {
    color: '#45B14F',
    fontSize: '14px',
    textDecoration: 'none',
    fontWeight: '500',
  };

  return (
    <div className={clsx("news-insights-area", spaceTopClass, spaceBottomClass)}>
      <div className="container" style={{ marginBottom: 50, }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 50,
          marginTop: 50
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h4 style={{
              margin: 0,
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 600
            }}>
              News & Insight
            </h4>
            <div style={{
              height: 12,
              width: 12,
              background: "#45B14F",
              borderRadius: "50%",
              marginLeft: 8
            }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <button style={{
              background: "#1C4598",
              color: "white",
              height: "45px",
              width: "130px",
              borderRadius: "25px",
              border: "none",
              cursor: "pointer",
              fontWeight: "500",
              position: "relative"

            }
            }
              onClick={() => { navigate("/shop-grid-standard?USED") }}
            >

              SHOP NOW
            </button>
            <div style={{
              height: 8,
              width: 8,
              background: "#45B14F",
              borderRadius: "50%",
              marginLeft: -20,
              marginTop: 2
            }} />
          </div>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '30px',
          justifyItems: 'center'
        }}>
          {categoryData.map((item) => (
            <div key={item.id} style={cardStyle}>
              <div style={imageContainerStyle}>
                <img src={item.image} alt={item.title} style={imageStyle} />
                <span style={labelStyle}>{item.type}</span>
              </div>
              <div style={contentStyle}>
                <h3 style={titleStyle}>{item.title}</h3>
              </div>
              <div style={footerStyle}>
                <a href={item.link} style={readMoreStyle}>
                  Read More...
                </a>
                <span style={dateStyle}>{item.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div >
  );
};

NewsInsightSlider.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default NewsInsightSlider;